import React from 'react';
import { LayoutComponentNames, Skeleton } from '@diana/core';
import { Skeleton as MuiSkeleten, Stack } from '@mui/material';
import styled from 'styled-components';

interface IComponentBuilderLoaderProps {
  componentName: LayoutComponentNames;
}
export const NormalSizeSkeleton = styled(MuiSkeleten)({ transform: 'none' });

const TableComponentLoader = () => {
  return (
    <Stack gap={1} mt={1.5}>
      <NormalSizeSkeleton variant="text" width="50%" height={16} />
      <NormalSizeSkeleton variant="text" width="100%" height={36} />
      <NormalSizeSkeleton variant="rounded" width="100%" height={100} />
    </Stack>
  );
};

const DefaultCompomnentLoader = () => {
  return (
    <Stack gap={1} mt={1.5}>
      <NormalSizeSkeleton variant="text" width="50%" height={16} />
      <NormalSizeSkeleton variant="text" width="100%" height={36} />
    </Stack>
  );
};

export const ComponentBuilderLoader = ({ componentName }: IComponentBuilderLoaderProps) => {
  switch (componentName) {
    case LayoutComponentNames.SECTION:
      return <Skeleton count={3} />;
    case LayoutComponentNames.DATA_GRID:
      return <TableComponentLoader />;
    default:
      return <DefaultCompomnentLoader />;
  }
};
